import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/dreamz.academy/httpdocs/src/app/home-page/components/AboutSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/dreamz.academy/httpdocs/src/app/home-page/components/ContactSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/dreamz.academy/httpdocs/src/app/home-page/components/HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/dreamz.academy/httpdocs/src/app/home-page/components/ProcessSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/dreamz.academy/httpdocs/src/app/home-page/components/ServiceSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/dreamz.academy/httpdocs/src/app/home-page/components/StatsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/dreamz.academy/httpdocs/src/app/home-page/components/StickyMobileBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/dreamz.academy/httpdocs/src/app/home-page/components/TestimonialsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/dreamz.academy/httpdocs/src/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/dreamz.academy/httpdocs/src/components/ui/AppIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/dreamz.academy/httpdocs/src/components/ui/AppImage.tsx");
